import React from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  Tooltip,
  IconButton,
  Typography,
} from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import DeepResearchControls from "./DeepResearchControls";

export default function ContentGenerationDialog({
  open,
  onClose,
  onConfirm,
  mainOption,
  setMainOption,
  generateSpeakerNotes,
  setGenerateSpeakerNotes,
  // Deep research control props
  minBulletPointsSlide,
  setMinBulletPointsSlide,
  maxBulletPointsSlide,
  setMaxBulletPointsSlide,
  maxWordsBulletSlide,
  setMaxWordsBulletSlide,
  maxRows,
  setMaxRows,
  maxColumns,
  setMaxColumns,
  maxWordsPerCell,
  setMaxWordsPerCell,
  maxWordsTableSlide,
  setMaxWordsTableSlide,
  maxWordsSpeakerNotes,
  setMaxWordsSpeakerNotes,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Content Generation Options</DialogTitle>
      <DialogContent>
        <RadioGroup
          value={mainOption}
          onChange={(e) => setMainOption(e.target.value)}
        >
          {/* Option 1: Deep Research */}
          <Box
            mb={3}
            p={2}
            style={{ border: "2px solid #20677b", borderRadius: "8px" }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <FormControlLabel
                value="deepresearch"
                control={<Radio color="primary" style={{ padding: 0 }} />}
                label={
                  <Typography
                    variant="body1"
                    style={{
                      fontWeight: 600,
                      color: "rgba(0, 0, 0, 0.87)",
                      marginLeft: "8px",
                    }}
                  >
                    Conduct deep research to create content
                  </Typography>
                }
                style={{ alignItems: "flex-start", margin: 0 }}
              />
              <Tooltip
                title={
                  <Box>
                    <Typography variant="body2" gutterBottom>
                      Generate detailed content with speaker notes for each
                      slide
                    </Typography>
                    <Typography variant="caption">
                      ⏱ Takes 2-5 minutes per slide (30-40 minutes total for 30
                      slides)
                    </Typography>
                  </Box>
                }
                arrow
                placement="left"
              >
                <IconButton size="small">
                  <HelpOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>

            {mainOption === "deepresearch" && (
              <DeepResearchControls
                minBulletPointsSlide={minBulletPointsSlide}
                setMinBulletPointsSlide={setMinBulletPointsSlide}
                maxBulletPointsSlide={maxBulletPointsSlide}
                setMaxBulletPointsSlide={setMaxBulletPointsSlide}
                maxWordsBulletSlide={maxWordsBulletSlide}
                setMaxWordsBulletSlide={setMaxWordsBulletSlide}
                maxRows={maxRows}
                setMaxRows={setMaxRows}
                maxColumns={maxColumns}
                setMaxColumns={setMaxColumns}
                maxWordsPerCell={maxWordsPerCell}
                setMaxWordsPerCell={setMaxWordsPerCell}
                maxWordsTableSlide={maxWordsTableSlide}
                setMaxWordsTableSlide={setMaxWordsTableSlide}
                maxWordsSpeakerNotes={maxWordsSpeakerNotes}
                setMaxWordsSpeakerNotes={setMaxWordsSpeakerNotes}
              />
            )}
          </Box>

          {/* Option 2: Use Outline */}
          <Box
            p={2}
            style={{ border: "2px solid #20677b", borderRadius: "8px" }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <FormControlLabel
                value="useoutline"
                control={<Radio color="primary" style={{ padding: 0 }} />}
                label={
                  <Typography
                    variant="body1"
                    style={{
                      fontWeight: 600,
                      color: "rgba(0, 0, 0, 0.87)",
                      marginLeft: "8px",
                    }}
                  >
                    Use outline to create slides
                  </Typography>
                }
                style={{ alignItems: "flex-start", margin: 0 }}
              />
              <Tooltip
                title={
                  <Box>
                    <Typography variant="body2" gutterBottom>
                      Convert the outline directly to slides
                    </Typography>
                    <Typography variant="caption">
                      ⏱ Takes 3-10 minutes total
                    </Typography>
                  </Box>
                }
                arrow
                placement="left"
              >
                <IconButton size="small">
                  <HelpOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>

            {mainOption === "useoutline" && (
              <Box ml={4} mt={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={generateSpeakerNotes}
                      onChange={(e) =>
                        setGenerateSpeakerNotes(e.target.checked)
                      }
                      color="primary"
                      size="small"
                    />
                  }
                  label={
                    <Typography variant="body2" style={{ color: "black" }}>
                      Also generate speaker notes
                    </Typography>
                  }
                />
              </Box>
            )}
          </Box>
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="transparent">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="quCreateColor">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
